<template lang="pug">
	modal(:max-width="400", v-if="invitado")
		.card.text-left
			.card-header.bg-warning.text-dark
				span.fa.fa-user.mr-2
				| Invitado
				button.close(@click="cerrar") &times;
			.alert.alert-danger.text-center(v-if="eventoCerrado")
				span.fa.fa-ban
				br
				| Este evento está cerrado
			.card-body
				.form-group(v-if="!eventoCerrado")
					label Evento
					select.form-control(v-model="invitado.EventoID", @change="getGrupos", :disabled="eventoCerrado")
						option(:value="null") Selecciona
						option(
							v-for="evento in listadoEventos"
							:key="evento.EventoID"
							:value="evento.EventoID"
						) {{evento.Nombre}}
				.form-group(v-else)
					label Evento
					input.form-control(:value="invitado.EventoNombre", disabled)

				.form-group.mt-3
					label Grupo
					select.form-control(v-model="invitado.GrupoID", :disabled="eventoCerrado")
						option(:value="null") Selecciona
						option(
							v-for="grupo in listadoGrupos"
							:key="grupo.GrupoID"
							:value="grupo.GrupoID"
						) {{grupo.Nombre}}

				.form-group.mt-3
					label Nombre
					input.form-control(v-model="invitado.Nombre", placeholder="Nombre y apellidos", :disabled="eventoCerrado")

				.row
					.col
						.form-group.mt-3
							label Asistentes
							input.form-control(v-model.number="invitado.Asistentes", :disabled="eventoCerrado")
					.col
						.form-group.mt-3
							label Localidad(es)
							.input-group
								input.form-control(:class="localidadesCompletas != invitado.Asistentes ? 'bg-danger text-white' : 'bg-success text-white'", :value="localidadesCompletas != invitado.Asistentes ? invitado.Asistentes - localidadesCompletas + ' Pendientes' : 'Completas'", :disabled="true")
								.input-group-append
									button.btn(@click="editarLocalidades = true")
										span.fa.fa-edit

				.form-group.mt-3
					label Gestiona
					br
					b(v-if="!invitado.UsuarioOriginalNombre") {{usuario.nombre}} {{usuario.apellidos}}
					b(v-else) {{invitado.UsuarioOriginalNombre}}

				.row.mt-3
					.col
						.form-group
							label Estado
							select.form-control(v-model="invitado.Estado", :disabled="eventoCerrado")
								option(
									v-for="estado in listadoEstados"
									:value="estado"
									:key="estado"
								) {{estado}}
					.col
						.form-group
							label Personas VIP
							input.form-control(v-model.number="invitado.VIP", placeholder="0")

				.form-group.mt-3
					label Anotaciones
					textarea.form-control(v-model="invitado.Anotaciones", rows="5", placeholder="Anotaciones", :disabled="eventoCerrado")



			.card-footer(v-if="!eventoCerrado")
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
		EditorLocalidades(v-if="editarLocalidades", @cerrar="editarLocalidades = false", :invitado="invitado")
</template>


<script>
import EditorLocalidades from './localidades'
import { mapGetters } from 'vuex'
import API from '../../api'
export default {
	props: ['invitadoId'],
	components: {
		EditorLocalidades
	},
	data () {
		return {
			editarLocalidades: false,
			listadoEventos: [],
			listadoGrupos: [],
			listadoEstados: ['No avisado', 'Pendiente', 'Entregado', 'Confirmado', 'Denegado'],
			invitado: {
				InvitadoID: null,
				InvitadoOriginalID: null,
				Nombre: null,
				FechaCreacion: new Date(),
				FechaModificacion: null,
				EventoID: null,
				UsuarioID: null,
				Estado: 'No avisado',
				VIP: 0,
				Asistentes: 1,
				Localidades: [
					{
						Fila: null,
						Asiento: null,
						Nombre: null,
						Comentarios: null
					}
				],
				Anotaciones: null
			}
		}
	},
	watch: {
		'invitado.Asistentes': function (newVal) {
			this.actualizaLocalidades()
		}
	},
	created () {
		if (this.invitadoId === 'nuevo') {
			this.nuevo()
		} else {
			this.getInvitado()
		}

		API.getEventos(true)
			.then(res => {
				this.listadoEventos = res.data
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Error obteniendo el listado de eventos'
				})
			})
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		}),
		localidadesCompletas () {
			return this.invitado.Localidades.reduce((acum, actual) => {
				if (actual.Fila && actual.Asiento) {
					acum++
				}
				return acum
			}, 0)
		},
		eventoCerrado () {
			if (!this.invitado.EventoID) {
				return false
			} else if (!this.invitado.EventoEstado) {
				return false
			} else {
				return (this.invitado.EventoEstado === 'Cerrado')
			}
		}
	},
	methods: {
		nuevo () {
			this.invitado = {
				InvitadoID: null,
				InvitadoOriginalID: null,
				Nombre: null,
				FechaCreacion: new Date(),
				FechaModificacion: null,
				EventoID: null,
				UsuarioID: this.usuario.ID,
				Estado: 'No avisado',
				VIP: 0,
				Asistentes: 1,
				Localidades: [
					{
						Fila: null,
						Asiento: null,
						Nombre: null,
						Comentarios: null
					}
				],
				Anotaciones: null
			}
			this.actualizaLocalidades()
		},
		actualizaLocalidades () {
			const exp = /^[0-9]{1,}$/
			let newVal = this.invitado.Asistentes
			if (!exp.test(newVal)) {
				this.invitado.Localidades = []
			} else {
				newVal = parseInt(newVal)
				const oldVal = this.invitado.Localidades.length
				if (!exp.test(oldVal)) {
					this.invitado.Localidades = []
					for (let i = 0; i < newVal; i++) {
						this.invitado.Localidades.push({
							LocalidadID: null,
							Fila: null,
							Asiento: null,
							Nombre: null,
							Comentarios: null
						})
					}
				} else if (oldVal > newVal) {
					this.invitado.Localidades.splice(newVal)
				} else {
					for (let i = oldVal; i < newVal; i++) {
						this.invitado.Localidades.push({
							LocalidadID: null,
							Fila: null,
							Asiento: null,
							Nombre: null,
							Comentarios: null
						})
					}
				}
			}
		},
		getGrupos () {
			if (!this.invitado.EventoID) {
				return
			}

			API.getGrupos(this.invitado.EventoID)
				.then(res => {
					this.listadoGrupos = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.reponse.data.error
					})
				})
		},
		getInvitado () {
			API.getInvitado(this.invitadoId)
				.then(res => {
					this.invitado = res.data
					this.getGrupos()
					this.actualizaLocalidades()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.reponse.data.error
					})
				})
		},
		guardar () {
			API.setInvitado(this.invitado)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Guardado',
						mensaje: 'Se han guardado los cambios'
					})
					this.invitado = res.data
					this.$emit('guardado', this.invitado)
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/components/editor/main.vue